import { FC } from "react";
import { Radio } from "shared/components";
import { ApplicantStatus, ApplicantType } from "shared/types";
import { Applicant } from "types/application";
import { Check, Loading02, XClose } from "untitledui-js-base";
import { getApplicantRole } from "utils/getApplicantRole";

export const ApplicantRadioCard: FC<{
  onClick: () => void;
  id: string;
  role: ApplicantType | null;
  fullName: string;
  checked: boolean;
  isSubmitted?: boolean;
  applicant?: Applicant;
  isPrimary?: boolean;
}> = ({
  id,
  checked,
  onClick,
  role,
  fullName,
  isSubmitted,
  applicant,
  isPrimary
}) => {
  return (
    <div
      onClick={() => {
        onClick();
      }}
      className="p-3 md:p-5 border-r border-alpha-40 flex w-full h-[64px] md:h-[80px] shrink-0 hover:bg-alpha-20 cursor-pointer"
    >
      <Radio
        className="mr-4 self-center cursor-pointer"
        id={`applicantId_${id}`}
        checked={checked}
        name={`applicantId_${id}`}
        onClick={() => {
          // readonly. don't use me
        }}
        onChange={() => {
          // readonly. don't use me
        }}
        label=""
      />

      <label
        className="mr-2 cursor-pointer self-center"
        htmlFor={`applicantId_${id}`}
      >
        <div className="w-full grow">
          <div className="flex items-center gap-2">
            <h2 className="text-sm font-bold text-content-1000">{fullName}</h2>

            {isSubmitted ? (
              <Check size="16px" className="stroke-success-600 stroke-[2px]" />
            ) : applicant?.application_status === ApplicantStatus.Canceled ? (
              <XClose size="16px" className="stroke-content-200 stroke-[2px]" />
            ) : (
              <Loading02 size="16px" className="stroke-warning-600" />
            )}
          </div>

          <p className="text-sm text-content-400">
            {getApplicantRole(role, isPrimary)}
          </p>
        </div>
      </label>
    </div>
  );
};
